var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 75C150.5 116.424 116.924 150 75.5 150C34.0757 150 0.5 116.424 0.5 75C0.5 33.5757 34.0757 0 75.5 0C116.924 0 150.5 33.5757 150.5 75Z",
    fill: "#2168AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.697 47.3189C119.105 46.7837 118.319 46.4675 117.459 46.4675H33.5404C32.6809 46.4675 31.8944 46.7837 31.3025 47.3189C30.6214 47.9432 30.1836 48.8351 30.1836 49.8243V100.176C30.1836 101.165 30.6214 102.057 31.3025 102.681C31.8944 103.216 32.6809 103.532 33.5404 103.532H117.459C118.335 103.532 119.121 103.216 119.713 102.665C120.403 102.041 120.816 101.149 120.816 100.176V49.8243C120.816 48.8351 120.378 47.9432 119.697 47.3189Z",
    fill: "#FE9C28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6268 74.9999L31.3025 102.681C30.6214 102.057 30.1836 101.165 30.1836 100.176V49.8243C30.1836 48.8351 30.6214 47.9432 31.3025 47.3188L67.6268 74.9999Z",
    fill: "#FEBD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.816 49.8243V100.176C120.816 101.149 120.403 102.04 119.714 102.665L83.373 74.9999L119.697 47.3188C120.378 47.9432 120.816 48.8351 120.816 49.8243Z",
    fill: "#FEBD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.697 47.3189L83.373 75L77.8027 79.2486C76.4406 80.3027 74.5595 80.3027 73.1973 79.2486L67.6271 75L31.3027 47.3189C31.8946 46.7837 32.6811 46.4675 33.5406 46.4675H117.459C118.319 46.4675 119.105 46.7837 119.697 47.3189Z",
    fill: "#FFD734"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.262 46.1028C130.262 52.1353 125.373 57.0326 119.332 57.0326C113.3 57.0326 108.402 52.1353 108.402 46.1028C108.402 40.0623 113.3 35.1731 119.332 35.1731C125.373 35.1731 130.262 40.0623 130.262 46.1028Z",
    fill: "#E04149"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.545 49.8243V42.7946L116.932 43.6784V42.2108L119.007 41.0757H120.297V49.8243H121.732V51.1216H116.988V49.8243H118.545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerifyIcon);
export default __webpack_public_path__ + "static/media/emailVerifyIcon.dea733100ae898b6467d1a6f7aa368ce.svg";
export { ForwardRef as ReactComponent };